<template>
	<div
		:class="[
			'calendar-btn-wrapper',
			{ tutorial: isTutorial, disabled: disabled }
		]"
	>
		<div class="calendar-btn">
			<ja-button
				:class="['transparent', { 'skip-disable': isTutorial }]"
				name="calendar-button"
				:disabled="disabled"
				:aria-label="$t('goCalendar')"
				@click.native="goToCalendar"
			>
				<svgicon name="calendar" :original="true"></svgicon>
				<div class="text-calendar-btn">
					<div>{{ $t('monthly') }}</div>
					<div>{{ $t('expenses') }}</div>
				</div>
			</ja-button>
			<ja-tooltip
				v-if="isTutorial"
				class="tooltip top center skip-disable"
				:pointer="true"
				tabindex="0"
				@click.native="goToCalendar"
			>
				<div class="heading-4 title-tooltip">
					{{ $t('calendarОnboardingTitle') }}
				</div>
				<div class="body-text-1">
					{{ $t('calendarОnboarding') }}
				</div>
			</ja-tooltip>
		</div>
	</div>
</template>
<script>
import Tooltip from '../ui/Tooltip';
import Button from '../ui/Button';
import '../../components/icons/calendar';

export default {
	components: {
		jaTooltip: Tooltip,
		jaButton: Button
	},
	props: {
		isTutorial: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if (this.isTutorial) {
			this.$announcer.polite(this.$t('tutorialStarted'));
		}
	},
	methods: {
		goToCalendar() {
			if (!this.disabled) {
				this.$store.commit('setLoading', true);
				this.$router.push({ name: 'calendar' });
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.calendar-btn-wrapper {
	z-index: 2;
	position: absolute;
	height: 122px;
	width: 100%;
	background: linear-gradient(180deg, #808b67 0%, rgba(150, 174, 113, 0) 100%);
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	&.disabled {
		.calendar-btn {
			&:hover {
				cursor: default;
			}
		}
	}

	&.tutorial {
		z-index: 9;
	}

	.calendar-btn {
		height: 90px;
		width: 80px;
		position: relative;
		margin: 32px auto 0 auto;
		box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.25);
		border-radius: 9px;
		svg {
			height: 100%;
			width: 100%;
		}

		button {
			border-radius: 0px;
			.text-calendar-btn {
				position: absolute;
				text-transform: uppercase;
				font-family: 'RobotoMedium';
				font-size: 14px;
				letter-spacing: 0.25px;
				font-weight: normal;
				letter-spacing: initial;
				color: $font-header;
				text-align: center;
				width: 80px;
				bottom: 12px;
			}
		}

		&:hover {
			cursor: pointer;
		}

		.tooltip {
			width: 300px;
			height: fit-content;
			text-align: center;
			transform: translate(-50%, 100%);
			left: 40px;
			bottom: -18px;
			padding: 24px 24px 16px 24px;

			h2 {
				margin: 0;
			}

			.title-tooltip {
				margin-top: 0;
				margin-bottom: 4px;
				color: $font-header;
			}
			button {
				height: auto;
				margin-top: 24px;
			}
		}
	}
}
</style>
